"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDatetime = _interopRequireDefault(require("react-datetime"));

var _utils = require("./utils");

var MDY_DATE_FORMAT = 'Y-MM-DD';
var TIME_FORMAT = 'HH:mm zz';

var DatePicker =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2["default"])(DatePicker, _PureComponent);

  function DatePicker() {
    (0, _classCallCheck2["default"])(this, DatePicker);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(DatePicker).apply(this, arguments));
  }

  (0, _createClass2["default"])(DatePicker, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          readonly = _this$props.readonly,
          placeholder = _this$props.placeholder,
          disabled = _this$props.disabled,
          required = _this$props.required,
          onClickInput = _this$props.onClickInput,
          initialValue = _this$props.initialValue,
          initialViewDate = _this$props.initialViewDate,
          initialViewMode = _this$props.initialViewMode,
          onNavigate = _this$props.onNavigate,
          defaultValue = _this$props.defaultValue,
          viewMode = _this$props.viewMode,
          defaultViewDate = _this$props.defaultViewDate,
          closeOnClickOutside = _this$props.closeOnClickOutside,
          disableCloseOnClickOutside = _this$props.disableCloseOnClickOutside,
          onOpen = _this$props.onOpen,
          onClose = _this$props.onClose,
          onBlur = _this$props.onBlur,
          onFocus = _this$props.onFocus,
          onViewModeChange = _this$props.onViewModeChange,
          rest = (0, _objectWithoutProperties2["default"])(_this$props, ["readonly", "placeholder", "disabled", "required", "onClickInput", "initialValue", "initialViewDate", "initialViewMode", "onNavigate", "defaultValue", "viewMode", "defaultViewDate", "closeOnClickOutside", "disableCloseOnClickOutside", "onOpen", "onClose", "onBlur", "onFocus", "onViewModeChange"]);
      return _react["default"].createElement("div", {
        className: "datetime"
      }, _react["default"].createElement(_reactDatetime["default"], (0, _extends2["default"])({
        dateFormat: MDY_DATE_FORMAT,
        timeFormat: TIME_FORMAT,
        inputProps: {
          readOnly: readonly,
          placeholder: placeholder,
          disabled: disabled,
          required: required,
          onClick: onClickInput
        },
        initialValue: initialValue || defaultValue // react-datetime v2->v3 compatibility
        ,
        initialViewDate: initialViewDate || defaultViewDate // react-datetime v2->v3 compatibility
        ,
        initialViewMode: initialViewMode || viewMode // react-datetime v2->v3 compatibility
        ,
        closeOnClickOutside: closeOnClickOutside || !disableCloseOnClickOutside // react-datetime v2->v3 compatibility
        ,
        onNavigate: onNavigate || onViewModeChange // react-datetime v2->v3 compatibility
        ,
        onOpen: onOpen || onFocus // react-datetime v2->v3 compatibility
        ,
        onClose: onClose || onBlur // react-datetime v2->v3 compatibility

      }, rest)), _react["default"].createElement("i", {
        className: "fa fa-calendar",
        "aria-hidden": "true"
      }));
    }
  }]);
  return DatePicker;
}(_react.PureComponent);

(0, _defineProperty2["default"])(DatePicker, "propTypes", {
  placeholder: _propTypes["default"].string,
  readonly: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  required: _propTypes["default"].bool,
  onClickInput: _propTypes["default"].string,
  initialValue: _propTypes["default"].instanceOf(Date),
  initialViewMode: _propTypes["default"].string,
  initialViewDate: _propTypes["default"].instanceOf(Date),
  closeOnClickOutside: _propTypes["default"].bool,
  onOpen: _propTypes["default"].func,
  onClose: _propTypes["default"].func,
  onNavigate: _propTypes["default"].func,
  defaultValue: (0, _utils.deprecatedProp)(_propTypes["default"].instanceOf(Date), 'Use initialValue instead'),
  viewMode: (0, _utils.deprecatedProp)(_propTypes["default"].string, 'Use initialViewMode instead'),
  defaultViewDate: (0, _utils.deprecatedProp)(_propTypes["default"].instanceOf(Date), 'Use initialViewDate instead'),
  disableCloseOnClickOutside: (0, _utils.deprecatedProp)(_propTypes["default"].bool, 'Use closeOnClickOutside instead'),
  onBlur: (0, _utils.deprecatedProp)(_propTypes["default"].func, 'Use onOpen instead'),
  onFocus: (0, _utils.deprecatedProp)(_propTypes["default"].func, 'Use onClose instead'),
  onViewModeChange: (0, _utils.deprecatedProp)(_propTypes["default"].func, 'Use onNavigate instead')
});
var _default = DatePicker;
exports["default"] = _default;